// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Printer config tabs ── */
.pc-tab-row {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 6px;
  border: 1px solid rgba(226, 232, 240, 0.82);
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.76);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.88), 0 12px 28px rgba(15, 23, 42, 0.05);
  backdrop-filter: blur(14px);
}

.pc-tab-btn {
  flex: 1;
  min-height: 46px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 14px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
  white-space: nowrap;
  text-align: center;
  line-height: 1.3;
}

.pc-tab-btn:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: #dbeafe;
  color: #1d4ed8;
  transform: translateY(-1px);
}

.pc-tab-btn--active {
  background: linear-gradient(135deg, #2a71ff 0%, #1559dc 100%);
  border-color: rgba(42, 113, 255, 0.9);
  color: #fff;
  box-shadow: 0 14px 28px rgba(42, 113, 255, 0.28);
}

.pc-tab-btn--active:hover {
  background: linear-gradient(135deg, #246bfe 0%, #144fc4 100%);
  border-color: rgba(42, 113, 255, 0.95);
  color: #fff;
}

.settingsContainer {
  max-width: 400px;
  margin: auto;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.settingGroup {
  margin-bottom: 20px;
}

.settingGroup label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.settingGroup select,
.settingGroup input[type="range"] {
  width: 100%;
}

.recommendation {
  margin-top: 8px;
  font-size: 13px;
  color: #007aff;
}

.saveButton {
  width: 100%;
  padding: 10px;
  background-color: #007aff;
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-weight: bold;
}

.print-config-test-save-print-container {
  display: flex;
  gap: 10px;
}

.printer-config-setup-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  padding: 9px 16px;
  border: 1px solid rgba(235, 168, 90, 0.7);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(255, 250, 242, 0.78) 0%, rgba(255, 255, 255, 0.92) 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 10px 24px rgba(235, 168, 90, 0.08);
  color: #d98228;
  cursor: pointer;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.printer-config-setup-btn:hover {
  border-color: #eba85a;
  background: linear-gradient(180deg, rgba(255, 246, 232, 0.96) 0%, #ffffff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), 0 14px 28px rgba(235, 168, 90, 0.14);
  transform: translateY(-1px);
}

.printer-config-setup-btn svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.printer-config-page-shell {
  width: 100%;
  max-width: 1152px;
  min-height: 70vh;
  margin: 70px auto 0;
  padding: 14px 24px 84px;
}

.printer-config-workspace {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.thermal-template-page-bar {
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.thermal-template-page-bar__title-wrap {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.thermal-template-page-bar__back {
  display: grid;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  place-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.thermal-template-page-bar__back:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}

.thermal-template-page-bar__back svg {
  width: 20px;
  height: 20px;
  stroke-width: 2.2;
}

.thermal-template-page-bar__title {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.thermal-template-page-bar__save {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 8px 16px;
  border: 1px solid #2a71ff;
  border-radius: 14px;
  background: #2a71ff;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  transition: background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
  white-space: nowrap;
}

.thermal-template-page-bar__save:hover {
  background: #1f63ea;
  box-shadow: 0 10px 20px rgba(42, 113, 255, 0.18);
  transform: translateY(-1px);
}

.thermal-template-page-bar__save svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.thermal-template-page-bar__save-short {
  display: none;
}

.print-config-template-action-row {
  align-items: center;
  margin-top: 18px;
  padding: 13px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.82);
}

.print-config-selected-template {
  min-width: 0;
  flex: 1 1 auto;
}

.print-config-selected-template__label {
  color: #111827;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
}

.print-config-selected-template__name {
  margin-top: 3px !important;
  overflow: hidden;
  color: #64748b;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1.3 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.printer-config-title-p {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

.printer-config-content-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 370px;
  gap: 20px;
  align-items: flex-start;
  padding-bottom: 60px
}

.printer-config-content-main {
  flex: 1 1 0;
  min-width: 0;
}

.thermal-template-library {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 16px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(18px);
}

.thermal-template-library__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.thermal-template-library__heading {
  max-width: 520px;
  min-width: 0;
}

.thermal-template-library__eyebrow {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #8a98b2;
  letter-spacing: 0.22em !important;
  text-transform: uppercase;
}

.thermal-template-library__title {
  margin-top: 6px !important;
  color: #0f172a;
  font-size: 22px !important;
  font-weight: 800 !important;
  line-height: 1.25 !important;
}

.thermal-template-library__copy {
  margin-top: 10px !important;
  color: #64748b;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.75 !important;
}

.thermal-template-library__count {
  flex: 0 0 auto;
  align-self: flex-start;
  padding: 8px 14px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
}

.thermal-template-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.thermal-template-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  min-width: 0;
  min-height: 292px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  background: #ffffff;
  color: #0f172a;
  cursor: pointer;
  text-align: left;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease,
    background 0.18s ease;
}

.thermal-template-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  transform: translateY(-2px);
}

.thermal-template-card--active {
  border-color: #2a71ff;
  background: rgba(239, 246, 255, 0.72);
  box-shadow: 0 16px 40px rgba(42, 113, 255, 0.16);
}

.thermal-template-card__preview {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  height: 174px;
  padding: 16px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.thermal-template-card__image {
  width: 100%;
  height: 100%;
  max-width: 100%;
  object-fit: contain;
  object-position: top center;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
}

.thermal-template-card__fallback {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 78%;
  margin-top: 28px;
}

.thermal-template-card__fallback span {
  height: 8px;
  border-radius: 8px;
  background: #d8e1ee;
}

.thermal-template-card__fallback span:nth-child(2) {
  width: 72%;
}

.thermal-template-card__fallback span:nth-child(3) {
  width: 88%;
}

.thermal-template-card__body {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  padding-right: 42px;
}

.thermal-template-card__name {
  color: #111827;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
}

.thermal-template-card__meta {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
}

.thermal-template-card__check {
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  background: #ffffff;
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
}

.thermal-template-card__check svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.5;
}

.thermal-template-card--active .thermal-template-card__check {
  border-color: #2a71ff;
  background: #2a71ff;
  color: #ffffff;
}

.thermal-template-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  border: 1px dashed #cbd5e1;
  border-radius: 22px;
  background: rgba(248, 250, 252, 0.8);
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.thermal-config-dummy-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-top: 22px;
}

.thermal-config-dummy-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(18px);
  cursor: pointer;
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.thermal-config-dummy-card:hover {
  border-color: #dbeafe;
  box-shadow: 0 22px 54px rgba(15, 23, 42, 0.11);
  transform: translateY(-2px);
}

.thermal-config-dummy-card__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.thermal-config-dummy-card__icon {
  display: grid;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 16px;
  background: #f1f5f9;
  color: #64748b;
}

.thermal-config-dummy-card__icon svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}

.thermal-config-dummy-card__eyebrow {
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}

.thermal-config-dummy-card__title {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}

.thermal-config-dummy-card__copy {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.8;
}

.thermal-config-dummy-card__panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.82);
}

.thermal-config-dummy-card__panel-title {
  margin: 0;
  color: #111827;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
}

.thermal-config-dummy-card__panel-copy {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.6;
}

.thermal-config-dummy-card__switch {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  width: 38px;
  height: 22px;
  padding: 2px;
  border-radius: 999px;
  background: #2a71ff;
}

.thermal-config-dummy-card__switch-thumb {
  display: block;
  width: 18px;
  height: 18px;
  margin-left: auto;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.2);
}

.thermal-config-dummy-card__segmented {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.thermal-config-dummy-card__segmented span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: #ffffff;
  color: #64748b;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

.thermal-config-dummy-card__segmented-active {
  border-color: #2a71ff !important;
  background: #eff6ff !important;
  color: #2a71ff !important;
}

.thermal-config-dummy-card__note {
  min-height: 180px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 22px;
  background: rgba(248, 250, 252, 0.72);
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.75;
}

.printer-config-content-side {
  width: 100%;
  max-width: 370px;
  display: none;
  justify-content: center;
  align-items: flex-start;
}

.thermal-live-preview-card {
  position: sticky;
  top: 82px;
  width: 100%;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(18px);
}

.thermal-live-preview-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 20px;
}

.thermal-live-preview-card__eyebrow {
  color: #8a98b2;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.22em !important;
  text-transform: uppercase;
}

.thermal-live-preview-card__title {
  margin-top: 4px !important;
  color: #0f172a;
  font-size: 18px !important;
  font-weight: 800 !important;
  line-height: 1.25 !important;
}

.thermal-live-preview-card__status {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.thermal-live-preview-card__status svg {
  width: 14px;
  height: 14px;
  stroke-width: 2.4;
}

.thermal-live-preview-card__receipt-shell {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  padding: 16px;
  border: 1px solid #cbd5e1;
  border-radius: 28px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.10);
}

.thermal-live-preview-card__receipt-paper {
  display: flex;
  justify-content: center;
  overflow: hidden;
  min-height: 430px;
  max-height: 560px;
  border: 1px solid #e2e8f0;
  border-radius: 22px;
  background: #ffffff;
  padding: 14px;
}

.thermal-template-preview-image {
  width: 100%;
  max-height: 540px;
  object-fit: contain;
  object-position: top center;
  border-radius: 12px;
}

.thermal-live-preview-card__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  padding: 13px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.82);
}

.thermal-live-preview-card__summary > button,
.thermal-live-preview-card__summary > div:last-child {
  flex: 0 0 auto;
}

.thermal-live-preview-card__summary > button {
  border-radius: 14px;
}

.thermal-live-preview-card__summary-title {
  color: #111827;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
}

.thermal-live-preview-card__summary-text {
  margin-top: 3px !important;
  color: #64748b;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1.3 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 900px) {
  .printer-config-content-side {
    display: flex;
  }
}

@media (max-width: 980px) {
  .printer-config-content-row {
    grid-template-columns: 1fr;
  }

  .printer-config-content-side {
    max-width: none;
    width: 100%;
  }

  .thermal-live-preview-card {
    position: static;
  }
}

@media (max-width: 760px) {
  .printer-config-page-shell {
    padding: 12px 14px 84px;
  }

  .thermal-template-grid {
    grid-template-columns: 1fr;
  }

  .thermal-template-library__header {
    flex-direction: column;
  }

  .thermal-config-dummy-grid {
    grid-template-columns: 1fr;
  }

  .thermal-config-dummy-card__segmented {
    grid-template-columns: 1fr;
  }

  .thermal-template-page-bar__save-full {
    display: none;
  }

  .thermal-template-page-bar__save-short {
    display: inline;
  }

  .print-config-template-action-row {
    align-items: stretch;
  }
}

.label-tester-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.label-preview-card,
.label-custom-card {
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #f8fafc;
}

.label-preview-card--side {
  width: 100%;
}

.label-preview-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.label-preview-meta {
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
}

.label-preview-canvas {
  display: grid;
  align-items: stretch;
  justify-content: start;
  margin-top: 14px;
  padding: 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
}

.label-preview-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 72px;
  padding: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  overflow: hidden;
}

.label-preview-text {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
}

.label-preview-subtext {
  font-size: 10px;
  line-height: 1.2;
  color: #475569;
}

/* Review Styles Button matching reference styling */
.review-styles-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  border: 1px solid transparent;
  padding: 8px 16px;
  gap: 8px;
  white-space: nowrap;
  color: #475569;
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
}

.review-styles-btn:hover {
  background-color: #f7f7f7;
  /* border-color: #cbd5e1; /* slate-200 border */
  /* box-shadow: 0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.05);  */
}

.review-styles-btn:active {
  transform: translateY(0.5px);
}

.review-styles-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
}

.review-styles-btn svg.arrow-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  pointer-events: none;
}

/* ── Dark mode ── */
.dark .pc-tab-row {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 12px 28px rgba(0, 0, 0, 0.3);
}

.dark .pc-tab-btn {
  color: #94a3b8;
}

.dark .pc-tab-btn:hover {
  background: rgba(51, 65, 85, 0.9);
  border-color: #334155;
  color: #f1f5f9;
}

.dark .settingsContainer {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .thermal-template-page-bar__back {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark .thermal-template-page-bar__back:hover {
  background: #334155;
  border-color: #475569;
  color: #f1f5f9;
}

.dark .thermal-template-page-bar__title {
  color: #f1f5f9;
}

.dark .print-config-template-action-row {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
}

.dark .print-config-selected-template__label {
  color: #f1f5f9;
}

.dark .print-config-selected-template__name {
  color: #94a3b8;
}

.dark .printer-config-title-p {
  color: #f1f5f9;
}

.dark .thermal-template-library {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
}

.dark .thermal-template-library__title {
  color: #f1f5f9;
}

.dark .thermal-template-library__copy {
  color: #94a3b8;
}

.dark .thermal-template-library__count {
  background: #1e3a5f;
  border-color: #1d4ed8;
  color: #93c5fd;
}

.dark .thermal-template-card {
  background: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .thermal-template-card:hover {
  border-color: #475569;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

.dark .thermal-template-card--active {
  border-color: #2a71ff;
  background: rgba(30, 58, 95, 0.72);
}

.dark .thermal-template-card__preview {
  background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);
  border-color: #334155;
}

.dark .thermal-template-card__name {
  color: #f1f5f9;
}

.dark .thermal-template-card__meta {
  color: #94a3b8;
}

.dark .thermal-template-card__check {
  background: #334155;
  border-color: #475569;
  color: #64748b;
}

.dark .thermal-template-empty {
  background: rgba(30, 41, 59, 0.8);
  border-color: #334155;
  color: #94a3b8;
}

.dark .thermal-config-dummy-card {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
}

.dark .thermal-config-dummy-card__icon {
  background: #334155;
  color: #94a3b8;
}

.dark .thermal-config-dummy-card__title {
  color: #f1f5f9;
}

.dark .thermal-config-dummy-card__copy {
  color: #94a3b8;
}

.dark .thermal-config-dummy-card__panel {
  background: rgba(15, 23, 42, 0.82);
  border-color: #334155;
}

.dark .thermal-config-dummy-card__panel-title {
  color: #f1f5f9;
}

.dark .thermal-config-dummy-card__panel-copy {
  color: #94a3b8;
}

.dark .thermal-config-dummy-card__segmented span {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark .thermal-config-dummy-card__note {
  background: rgba(15, 23, 42, 0.72);
  border-color: #334155;
  color: #94a3b8;
}

.dark .thermal-live-preview-card {
  background: rgba(30, 41, 59, 0.9);
  border-color: #334155;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
}

.dark .thermal-live-preview-card__title {
  color: #f1f5f9;
}

.dark .thermal-live-preview-card__status {
  background: #1e3a5f;
  border-color: #1d4ed8;
  color: #93c5fd;
}

.dark .thermal-live-preview-card__receipt-shell {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-color: #334155;
}

.dark .thermal-live-preview-card__receipt-paper {
  background: #0f172a;
  border-color: #334155;
}

.dark .thermal-live-preview-card__summary {
  background: rgba(15, 23, 42, 0.82);
  border-color: #334155;
}

.dark .thermal-live-preview-card__summary-title {
  color: #f1f5f9;
}

.dark .thermal-live-preview-card__summary-text {
  color: #94a3b8;
}

.dark .label-preview-card,
.dark .label-custom-card {
  background: #1e293b;
  border-color: #334155;
}

.dark .label-preview-title {
  color: #f1f5f9;
}

.dark .label-preview-meta {
  color: #94a3b8;
}

.dark .label-preview-canvas {
  background: #0f172a;
  border-color: #334155;
}

.dark .label-preview-item {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-color: #334155;
}

.dark .label-preview-text {
  color: #f1f5f9;
}

.dark .label-preview-subtext {
  color: #94a3b8;
}

.dark .review-styles-btn {
  background-color: #1e293b;
  color: #94a3b8;
}

.dark .review-styles-btn:hover {
  background-color: #334155;
}

.dark .printer-config-setup-btn {
  background: linear-gradient(180deg, rgba(30, 41, 59, 0.9) 0%, rgba(15, 23, 42, 0.95) 100%);
  border-color: rgba(235, 168, 90, 0.5);
  color: #e8a84a;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/PrinterConfiguration/index.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,uFAAuF;EACvF,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yHAAyH;EACzH,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,iGAAiG;EACjG,wFAAwF;EACxF,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uGAAuG;AACzG;;AAEA;EACE,qBAAqB;EACrB,+EAA+E;EAC/E,yFAAyF;EACzF,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8EAA8E;EAC9E,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,uBAAuB;EACvB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;yBACuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+EAA+E;EAC/E,6BAA6B;EAC7B,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,yEAAyE;AAC3E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,qBAAqB;EACrB,mFAAmF;AACrF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0FAA0F;EAC1F,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":["/* ── Printer config tabs ── */\n.pc-tab-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding: 6px;\n  border: 1px solid rgba(226, 232, 240, 0.82);\n  border-radius: 18px;\n  background: rgba(248, 250, 252, 0.76);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.88), 0 12px 28px rgba(15, 23, 42, 0.05);\n  backdrop-filter: blur(14px);\n}\n\n.pc-tab-btn {\n  flex: 1;\n  min-height: 46px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 14px;\n  padding: 12px 20px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #64748b;\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n  white-space: nowrap;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.pc-tab-btn:hover {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: #dbeafe;\n  color: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.pc-tab-btn--active {\n  background: linear-gradient(135deg, #2a71ff 0%, #1559dc 100%);\n  border-color: rgba(42, 113, 255, 0.9);\n  color: #fff;\n  box-shadow: 0 14px 28px rgba(42, 113, 255, 0.28);\n}\n\n.pc-tab-btn--active:hover {\n  background: linear-gradient(135deg, #246bfe 0%, #144fc4 100%);\n  border-color: rgba(42, 113, 255, 0.95);\n  color: #fff;\n}\n\n.settingsContainer {\n  max-width: 400px;\n  margin: auto;\n  padding: 20px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.settingGroup {\n  margin-bottom: 20px;\n}\n\n.settingGroup label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.settingGroup select,\n.settingGroup input[type=\"range\"] {\n  width: 100%;\n}\n\n.recommendation {\n  margin-top: 8px;\n  font-size: 13px;\n  color: #007aff;\n}\n\n.saveButton {\n  width: 100%;\n  padding: 10px;\n  background-color: #007aff;\n  border: none;\n  border-radius: 6px;\n  color: white;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.print-config-test-save-print-container {\n  display: flex;\n  gap: 10px;\n}\n\n.printer-config-setup-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 40px;\n  padding: 9px 16px;\n  border: 1px solid rgba(235, 168, 90, 0.7);\n  border-radius: 14px;\n  background: linear-gradient(180deg, rgba(255, 250, 242, 0.78) 0%, rgba(255, 255, 255, 0.92) 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 10px 24px rgba(235, 168, 90, 0.08);\n  color: #d98228;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1;\n  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\n\n.printer-config-setup-btn:hover {\n  border-color: #eba85a;\n  background: linear-gradient(180deg, rgba(255, 246, 232, 0.96) 0%, #ffffff 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), 0 14px 28px rgba(235, 168, 90, 0.14);\n  transform: translateY(-1px);\n}\n\n.printer-config-setup-btn svg {\n  width: 18px;\n  height: 18px;\n  stroke-width: 2;\n}\n\n.printer-config-page-shell {\n  width: 100%;\n  max-width: 1152px;\n  min-height: 70vh;\n  margin: 70px auto 0;\n  padding: 14px 24px 84px;\n}\n\n.printer-config-workspace {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.thermal-template-page-bar {\n  display: flex;\n  min-height: 56px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.thermal-template-page-bar__title-wrap {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 12px;\n}\n\n.thermal-template-page-bar__back {\n  display: grid;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  place-items: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 50%;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.thermal-template-page-bar__back:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.thermal-template-page-bar__back svg {\n  width: 20px;\n  height: 20px;\n  stroke-width: 2.2;\n}\n\n.thermal-template-page-bar__title {\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.thermal-template-page-bar__save {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 8px 16px;\n  border: 1px solid #2a71ff;\n  border-radius: 14px;\n  background: #2a71ff;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  transition: background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;\n  white-space: nowrap;\n}\n\n.thermal-template-page-bar__save:hover {\n  background: #1f63ea;\n  box-shadow: 0 10px 20px rgba(42, 113, 255, 0.18);\n  transform: translateY(-1px);\n}\n\n.thermal-template-page-bar__save svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.thermal-template-page-bar__save-short {\n  display: none;\n}\n\n.print-config-template-action-row {\n  align-items: center;\n  margin-top: 18px;\n  padding: 13px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  background: rgba(248, 250, 252, 0.82);\n}\n\n.print-config-selected-template {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.print-config-selected-template__label {\n  color: #111827;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 1.25 !important;\n}\n\n.print-config-selected-template__name {\n  margin-top: 3px !important;\n  overflow: hidden;\n  color: #64748b;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 1.3 !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.printer-config-title-p {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000000;\n}\n\n.printer-config-content-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 370px;\n  gap: 20px;\n  align-items: flex-start;\n  padding-bottom: 60px\n}\n\n.printer-config-content-main {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.thermal-template-library {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 16px;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.72);\n  border-radius: 28px;\n  background: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(18px);\n}\n\n.thermal-template-library__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.thermal-template-library__heading {\n  max-width: 520px;\n  min-width: 0;\n}\n\n.thermal-template-library__eyebrow {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: #8a98b2;\n  letter-spacing: 0.22em !important;\n  text-transform: uppercase;\n}\n\n.thermal-template-library__title {\n  margin-top: 6px !important;\n  color: #0f172a;\n  font-size: 22px !important;\n  font-weight: 800 !important;\n  line-height: 1.25 !important;\n}\n\n.thermal-template-library__copy {\n  margin-top: 10px !important;\n  color: #64748b;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 1.75 !important;\n}\n\n.thermal-template-library__count {\n  flex: 0 0 auto;\n  align-self: flex-start;\n  padding: 8px 14px;\n  border: 1px solid #dbeafe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  line-height: 1.2 !important;\n}\n\n.thermal-template-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.thermal-template-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 16px;\n  min-width: 0;\n  min-height: 292px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 24px;\n  background: #ffffff;\n  color: #0f172a;\n  cursor: pointer;\n  text-align: left;\n  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease,\n    background 0.18s ease;\n}\n\n.thermal-template-card:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);\n  transform: translateY(-2px);\n}\n\n.thermal-template-card--active {\n  border-color: #2a71ff;\n  background: rgba(239, 246, 255, 0.72);\n  box-shadow: 0 16px 40px rgba(42, 113, 255, 0.16);\n}\n\n.thermal-template-card__preview {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n  height: 174px;\n  padding: 16px;\n  overflow: hidden;\n  border: 1px solid #cbd5e1;\n  border-radius: 20px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.thermal-template-card__image {\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  object-position: top center;\n  border-radius: 12px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);\n}\n\n.thermal-template-card__fallback {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 78%;\n  margin-top: 28px;\n}\n\n.thermal-template-card__fallback span {\n  height: 8px;\n  border-radius: 8px;\n  background: #d8e1ee;\n}\n\n.thermal-template-card__fallback span:nth-child(2) {\n  width: 72%;\n}\n\n.thermal-template-card__fallback span:nth-child(3) {\n  width: 88%;\n}\n\n.thermal-template-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n  padding-right: 42px;\n}\n\n.thermal-template-card__name {\n  color: #111827;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.thermal-template-card__meta {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.thermal-template-card__check {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 50%;\n  background: #ffffff;\n  color: #cbd5e1;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.thermal-template-card__check svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2.5;\n}\n\n.thermal-template-card--active .thermal-template-card__check {\n  border-color: #2a71ff;\n  background: #2a71ff;\n  color: #ffffff;\n}\n\n.thermal-template-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 22px;\n  background: rgba(248, 250, 252, 0.8);\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.thermal-config-dummy-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n  margin-top: 22px;\n}\n\n.thermal-config-dummy-card {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  width: 100%;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.72);\n  border-radius: 28px;\n  background: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(18px);\n  cursor: pointer;\n  text-align: left;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.thermal-config-dummy-card:hover {\n  border-color: #dbeafe;\n  box-shadow: 0 22px 54px rgba(15, 23, 42, 0.11);\n  transform: translateY(-2px);\n}\n\n.thermal-config-dummy-card__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.thermal-config-dummy-card__icon {\n  display: grid;\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n  place-items: center;\n  border-radius: 16px;\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.thermal-config-dummy-card__icon svg {\n  width: 20px;\n  height: 20px;\n  stroke-width: 2;\n}\n\n.thermal-config-dummy-card__eyebrow {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n}\n\n.thermal-config-dummy-card__title {\n  margin: 4px 0 0;\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.thermal-config-dummy-card__copy {\n  margin: 8px 0 0;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.8;\n}\n\n.thermal-config-dummy-card__panel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  background: rgba(248, 250, 252, 0.82);\n}\n\n.thermal-config-dummy-card__panel-title {\n  margin: 0;\n  color: #111827;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.thermal-config-dummy-card__panel-copy {\n  margin: 6px 0 0;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.6;\n}\n\n.thermal-config-dummy-card__switch {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  width: 38px;\n  height: 22px;\n  padding: 2px;\n  border-radius: 999px;\n  background: #2a71ff;\n}\n\n.thermal-config-dummy-card__switch-thumb {\n  display: block;\n  width: 18px;\n  height: 18px;\n  margin-left: auto;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.2);\n}\n\n.thermal-config-dummy-card__segmented {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.thermal-config-dummy-card__segmented span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 46px;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  background: #ffffff;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.thermal-config-dummy-card__segmented-active {\n  border-color: #2a71ff !important;\n  background: #eff6ff !important;\n  color: #2a71ff !important;\n}\n\n.thermal-config-dummy-card__note {\n  min-height: 180px;\n  padding: 18px;\n  border: 1px solid #e2e8f0;\n  border-radius: 22px;\n  background: rgba(248, 250, 252, 0.72);\n  color: #475569;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.75;\n}\n\n.printer-config-content-side {\n  width: 100%;\n  max-width: 370px;\n  display: none;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.thermal-live-preview-card {\n  position: sticky;\n  top: 82px;\n  width: 100%;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.72);\n  border-radius: 30px;\n  background: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(18px);\n}\n\n.thermal-live-preview-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.thermal-live-preview-card__eyebrow {\n  color: #8a98b2;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.22em !important;\n  text-transform: uppercase;\n}\n\n.thermal-live-preview-card__title {\n  margin-top: 4px !important;\n  color: #0f172a;\n  font-size: 18px !important;\n  font-weight: 800 !important;\n  line-height: 1.25 !important;\n}\n\n.thermal-live-preview-card__status {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #dbeafe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.thermal-live-preview-card__status svg {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2.4;\n}\n\n.thermal-live-preview-card__receipt-shell {\n  width: 100%;\n  max-width: 320px;\n  margin: 0 auto;\n  padding: 16px;\n  border: 1px solid #cbd5e1;\n  border-radius: 28px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.10);\n}\n\n.thermal-live-preview-card__receipt-paper {\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n  min-height: 430px;\n  max-height: 560px;\n  border: 1px solid #e2e8f0;\n  border-radius: 22px;\n  background: #ffffff;\n  padding: 14px;\n}\n\n.thermal-template-preview-image {\n  width: 100%;\n  max-height: 540px;\n  object-fit: contain;\n  object-position: top center;\n  border-radius: 12px;\n}\n\n.thermal-live-preview-card__summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 18px;\n  padding: 13px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  background: rgba(248, 250, 252, 0.82);\n}\n\n.thermal-live-preview-card__summary > button,\n.thermal-live-preview-card__summary > div:last-child {\n  flex: 0 0 auto;\n}\n\n.thermal-live-preview-card__summary > button {\n  border-radius: 14px;\n}\n\n.thermal-live-preview-card__summary-title {\n  color: #111827;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 1.25 !important;\n}\n\n.thermal-live-preview-card__summary-text {\n  margin-top: 3px !important;\n  color: #64748b;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 1.3 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (min-width: 900px) {\n  .printer-config-content-side {\n    display: flex;\n  }\n}\n\n@media (max-width: 980px) {\n  .printer-config-content-row {\n    grid-template-columns: 1fr;\n  }\n\n  .printer-config-content-side {\n    max-width: none;\n    width: 100%;\n  }\n\n  .thermal-live-preview-card {\n    position: static;\n  }\n}\n\n@media (max-width: 760px) {\n  .printer-config-page-shell {\n    padding: 12px 14px 84px;\n  }\n\n  .thermal-template-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .thermal-template-library__header {\n    flex-direction: column;\n  }\n\n  .thermal-config-dummy-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .thermal-config-dummy-card__segmented {\n    grid-template-columns: 1fr;\n  }\n\n  .thermal-template-page-bar__save-full {\n    display: none;\n  }\n\n  .thermal-template-page-bar__save-short {\n    display: inline;\n  }\n\n  .print-config-template-action-row {\n    align-items: stretch;\n  }\n}\n\n.label-tester-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.label-preview-card,\n.label-custom-card {\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #f8fafc;\n}\n\n.label-preview-card--side {\n  width: 100%;\n}\n\n.label-preview-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.label-preview-meta {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.label-preview-canvas {\n  display: grid;\n  align-items: stretch;\n  justify-content: start;\n  margin-top: 14px;\n  padding: 10px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.label-preview-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 72px;\n  padding: 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  overflow: hidden;\n}\n\n.label-preview-text {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #0f172a;\n}\n\n.label-preview-subtext {\n  font-size: 10px;\n  line-height: 1.2;\n  color: #475569;\n}\n\n/* Review Styles Button matching reference styling */\n.review-styles-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  border: 1px solid transparent;\n  padding: 8px 16px;\n  gap: 8px;\n  white-space: nowrap;\n  color: #475569;\n  background-color: #ffffff;\n  cursor: pointer;\n  outline: none;\n}\n\n.review-styles-btn:hover {\n  background-color: #f7f7f7;\n  /* border-color: #cbd5e1; /* slate-200 border */\n  /* box-shadow: 0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.05);  */\n}\n\n.review-styles-btn:active {\n  transform: translateY(0.5px);\n}\n\n.review-styles-btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.review-styles-btn svg.arrow-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n/* ── Dark mode ── */\n.dark .pc-tab-row {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: #334155;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 12px 28px rgba(0, 0, 0, 0.3);\n}\n\n.dark .pc-tab-btn {\n  color: #94a3b8;\n}\n\n.dark .pc-tab-btn:hover {\n  background: rgba(51, 65, 85, 0.9);\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .settingsContainer {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .thermal-template-page-bar__back {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .thermal-template-page-bar__back:hover {\n  background: #334155;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.dark .thermal-template-page-bar__title {\n  color: #f1f5f9;\n}\n\n.dark .print-config-template-action-row {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: #334155;\n}\n\n.dark .print-config-selected-template__label {\n  color: #f1f5f9;\n}\n\n.dark .print-config-selected-template__name {\n  color: #94a3b8;\n}\n\n.dark .printer-config-title-p {\n  color: #f1f5f9;\n}\n\n.dark .thermal-template-library {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: #334155;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\n}\n\n.dark .thermal-template-library__title {\n  color: #f1f5f9;\n}\n\n.dark .thermal-template-library__copy {\n  color: #94a3b8;\n}\n\n.dark .thermal-template-library__count {\n  background: #1e3a5f;\n  border-color: #1d4ed8;\n  color: #93c5fd;\n}\n\n.dark .thermal-template-card {\n  background: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .thermal-template-card:hover {\n  border-color: #475569;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);\n}\n\n.dark .thermal-template-card--active {\n  border-color: #2a71ff;\n  background: rgba(30, 58, 95, 0.72);\n}\n\n.dark .thermal-template-card__preview {\n  background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);\n  border-color: #334155;\n}\n\n.dark .thermal-template-card__name {\n  color: #f1f5f9;\n}\n\n.dark .thermal-template-card__meta {\n  color: #94a3b8;\n}\n\n.dark .thermal-template-card__check {\n  background: #334155;\n  border-color: #475569;\n  color: #64748b;\n}\n\n.dark .thermal-template-empty {\n  background: rgba(30, 41, 59, 0.8);\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .thermal-config-dummy-card {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: #334155;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\n}\n\n.dark .thermal-config-dummy-card__icon {\n  background: #334155;\n  color: #94a3b8;\n}\n\n.dark .thermal-config-dummy-card__title {\n  color: #f1f5f9;\n}\n\n.dark .thermal-config-dummy-card__copy {\n  color: #94a3b8;\n}\n\n.dark .thermal-config-dummy-card__panel {\n  background: rgba(15, 23, 42, 0.82);\n  border-color: #334155;\n}\n\n.dark .thermal-config-dummy-card__panel-title {\n  color: #f1f5f9;\n}\n\n.dark .thermal-config-dummy-card__panel-copy {\n  color: #94a3b8;\n}\n\n.dark .thermal-config-dummy-card__segmented span {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .thermal-config-dummy-card__note {\n  background: rgba(15, 23, 42, 0.72);\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .thermal-live-preview-card {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: #334155;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\n}\n\n.dark .thermal-live-preview-card__title {\n  color: #f1f5f9;\n}\n\n.dark .thermal-live-preview-card__status {\n  background: #1e3a5f;\n  border-color: #1d4ed8;\n  color: #93c5fd;\n}\n\n.dark .thermal-live-preview-card__receipt-shell {\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  border-color: #334155;\n}\n\n.dark .thermal-live-preview-card__receipt-paper {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .thermal-live-preview-card__summary {\n  background: rgba(15, 23, 42, 0.82);\n  border-color: #334155;\n}\n\n.dark .thermal-live-preview-card__summary-title {\n  color: #f1f5f9;\n}\n\n.dark .thermal-live-preview-card__summary-text {\n  color: #94a3b8;\n}\n\n.dark .label-preview-card,\n.dark .label-custom-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .label-preview-title {\n  color: #f1f5f9;\n}\n\n.dark .label-preview-meta {\n  color: #94a3b8;\n}\n\n.dark .label-preview-canvas {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .label-preview-item {\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  border-color: #334155;\n}\n\n.dark .label-preview-text {\n  color: #f1f5f9;\n}\n\n.dark .label-preview-subtext {\n  color: #94a3b8;\n}\n\n.dark .review-styles-btn {\n  background-color: #1e293b;\n  color: #94a3b8;\n}\n\n.dark .review-styles-btn:hover {\n  background-color: #334155;\n}\n\n.dark .printer-config-setup-btn {\n  background: linear-gradient(180deg, rgba(30, 41, 59, 0.9) 0%, rgba(15, 23, 42, 0.95) 100%);\n  border-color: rgba(235, 168, 90, 0.5);\n  color: #e8a84a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
